import styled from 'styled-components';
import 'katex/dist/katex.min.css';

export const MarkdownAnswerStyles = styled.span`
  .markdown-answer-image-single,
  .markdown-answer-image-grid {
    margin: 16px 0;
  }

  .markdown-answer-image-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 16px;
    align-items: start;
  }

  .markdown-answer-image {
    display: block;
    width: 100%;
    max-width: 100%;
    height: auto;
    max-height: 420px;
    object-fit: contain;
    margin: 0 auto;
    border: 1px solid ${({ theme }) => theme.themeColors.border};
    border-radius: 6px;
    background: ${({ theme }) => theme.themeColors.appBackground};
  }

  .markdown-answer-image-single .markdown-answer-image {
    max-width: min(100%, 960px);
  }

  .markdown-answer-image-grid .markdown-answer-image {
    max-height: 320px;
  }

  pre {
    background-color: ${({ theme }) => theme.themeColors.lowContrastBorder};
    border-left: 3px solid ${({ theme }) => theme.themeColors.primaryCtaButton};
    color: ${({ theme }) => theme.themeColors.text};
    border-radius: 2px;

    margin-bottom: 1.6em;
    padding: 1em 1.5em;

    overflow: scroll;
    overflow-x: scroll;
    page-break-inside: avoid;

    * {
      line-height: 1.6;
    }
  }

  code {
    padding: 0 0.2em;

    .comment {
      /* Gray */
      color: #708090;
    }

    .string {
      /* Green */
      color: #0f9d58;
    }

    .keyword {
      /* Blue */
      color: #0086b3;
    }

    .function {
      /* Orange */
      color: #f08c00;
    }
  }

  td,
  th {
    padding: 8px;
  }

  th {
    background: ${({ theme }) => theme.themeColors.lowContrastBorder};
  }

  td {
    border: 1px solid ${({ theme }) => theme.themeColors.lowContrastBorder};
  }

  th,
  td {
    color: ${({ theme }) => theme.themeColors.text};
    border: 1px solid ${({ theme }) => theme.themeColors.lowContrastBorder};
    border-radius: 1px;
  }

  th {
    font-size: 12px;
    line-height: 14px;
    min-width: 120px;
  }

  ol,
  ul {
    padding-top: 8px;
    padding-bottom: 4px;
  }

  li {
    min-height: 28px;
    padding: 0 0 0 2px;
    margin-bottom: 12px;

    > span:first-child {
      display: block;
    }

    p {
      margin: 0;
    }
  }

  p {
    margin: 0 0 8px 0;
  }
`;
